import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import { Helmet } from "react-helmet-async";

/** Components */
import HomeBanner from '../components/HomeBanner';
import HomeBannerLogout from "../components/HomeBannerLogout";
import FeaturedPromotion from "../components/FeaturedPromotion";
import PromotionsRow from '../components/PromotionsRow';
import GamesRow from '../components/GamesRow';
import FilterRow from '../components/FilterRow';
import ProvidersRow from '../components/ProvidersRow';
import TopGamesNumbersRow from '../components/TopGamesNumbersRow';
import LastPlayedGamesRow from "../components/LastPlayedGamesRow";
import FreespinsRow from "../components/FreespinsRow";
import GamesRowColumns from "../components/GamesRowColumns";
import TagsRowSquares from "../components/TagsRowSquares";
import SupportedPaymentProviders from "../components/SupportedPaymentProviders";
import TotalJackpot from "../components/TotalJackpot";
import AllGamesRow from "../components/AllGamesRow";
import PhoneVerification from "../components/PhoneVerification";
import { BackgroundGradientHome } from "../components/BackgroundGradient";
import GamesSpotlightRow from "../components/GamesSpotlightRow";
import ResponsibleGaming from "../components/ResponsibleGaming";
import JackpotGamesRow from "../components/JackpotGamesRow";
import MustDropJackpotRow from "../components/MustDropJackpotRow";
import WeeklyBonus from "../components/WeeklyBonus";
import GamesRowPragmaticLive from "../components/GamesRowPragmaticLive";
import DGAConnect from "../components/DGAConnect";
import FirstDepositLottery from "../components/FirstDepositLottery";
import LimitedTimeFreeBonus from "../components/LimitedTimeFreeBonus";

import Footer from '../components/Footer';

export default function Home() {

    const userLoggedIn = useSelector((state) => state.user.isLoggedIn);
    const user = useSelector((state) => state.user.data);
    const limitTop = 25;
    const limitBottom = 1;

    function totalBalance() {
        const real = parseFloat(user.wagerBalance) + parseFloat(user.withdrawableBalance);
        const bonus = parseFloat(user.bonus[0]?.bonusDepositBalance || 0) + parseFloat(user.bonus[0]?.bonusDepositWinnings || 0) + parseFloat(user.bonus[0]?.bonusFreeBalance || 0) + parseFloat(user.bonus[0]?.bonusFreeWinnings || 0);
        return parseFloat(real) + parseFloat(bonus);
    }

    useEffect(() => { });

    return (
        <>
            <Helmet>
                <title>Home | Cherry Spins Casino</title>
            </Helmet>
            <DGAConnect />
            {
                !userLoggedIn && (
                    <>
                        <BackgroundGradientHome />
                        <HomeBannerLogout />
                        <GamesSpotlightRow categoryURL='home-spotlight' />
                        <PhoneVerification />
                        <MustDropJackpotRow categoryURL='daily-jackpot' title="Daily jackpot" type="daily" />
                        <WeeklyBonus />
                        <MustDropJackpotRow categoryURL='hourly-jackpot' title="Hourly Jackpot" type="hourly" />
                        <PromotionsRow />
                        <FilterRow />
                        <GamesRowPragmaticLive />
                        <GamesRow categoryURL='discover-new' moreGames={true} />
                        <TagsRowSquares categoryURL='all-slots' />
                        <GamesRow categoryURL='drops-and-wins' />
                        <GamesRowColumns categoryURL='table-games-columns' />
                        <GamesRow categoryURL='feature-lobby' moreGames={true} />
                        <AllGamesRow categoryURL='all-games' />
                        <GamesRow categoryURL='home-recommended' moreGames={true} />
                        <ProvidersRow categoryURL='game-providers' />
                        <LimitedTimeFreeBonus />
                        <ResponsibleGaming />
                        <Footer />
                    </>
                )
            }
            {
                userLoggedIn && (
                    <>
                        <BackgroundGradientHome />
                        <HomeBanner />
                        <FreespinsRow />
                        <PhoneVerification />
                        {
                            (parseFloat(totalBalance()) > limitTop) ? (
                                <>
                                    <LastPlayedGamesRow start={0} limit={10} title={'Jump back in'} />
                                    <LastPlayedGamesRow start={10} limit={20} title={'Time capsule'} />
                                    <GamesSpotlightRow categoryURL='home-spotlight' />
                                    <FeaturedPromotion />
                                    <FirstDepositLottery />
                                </>) : (
                                <>
                                    <FeaturedPromotion />
                                    <LastPlayedGamesRow start={0} limit={10} title={'Jump back in'} />
                                    <LastPlayedGamesRow start={10} limit={20} title={'Time capsule'} />
                                    <GamesSpotlightRow categoryURL='home-spotlight' />
                                    <FirstDepositLottery />
                                </>)
                        }
                        {
                            (Number.parseFloat(user?.wagerBalance) + Number.parseFloat(user?.withdrawableBalance) <= limitBottom) &&
                            (Number.parseFloat(user?.wagerBalance) + Number.parseFloat(user?.withdrawableBalance) > 0) && (
                                <GamesRow categoryURL='ten-cent' moreGames={true} />
                            )
                        }
                        <LimitedTimeFreeBonus />
                        <MustDropJackpotRow categoryURL='daily-jackpot' title="Daily jackpot" type="daily" />
                        <WeeklyBonus />
                        <MustDropJackpotRow categoryURL='hourly-jackpot' title="Hourly Jackpot" type="hourly" />
                        <PromotionsRow />
                        <GamesRow categoryURL='home-recommended' moreGames={true} personalized={true} />
                        <FilterRow />
                        <GamesRowPragmaticLive />
                        <GamesRow categoryURL='discover-new' moreGames={true} />
                        <TagsRowSquares categoryURL='all-slots' />
                        <GamesRow categoryURL='drops-and-wins' />
                        <GamesRowColumns categoryURL='table-games-columns' />
                        <GamesRow categoryURL='feature-lobby' moreGames={true} />
                        <AllGamesRow categoryURL='all-games' />
                        <GamesRow categoryURL='unique-games-lobby' moreGames={true} />
                        <ProvidersRow categoryURL='game-providers' />
                        <ResponsibleGaming />
                        <Footer />
                    </>
                )
            }
        </>
    );
}